import { initQueryParamTracker } from './queryParamTracker';

// Initialize query parameter tracking on every page load.
initQueryParamTracker();

/**
 * Broadcasts an event to the theme and other listeners.
 * Stores the last event detail on window.freeGift.detail.
 * @param {string} type - Event type, e.g., 'gwp:ready'.
 * @param {any} payload - Optional payload.
 */
export function emit(type, payload) {
  if (typeof window === 'undefined') return;
  /** @type {any} */ (window).freeGift = /** @type {any} */ (window).freeGift || {};
  /** @type {any} */ (window).freeGift.detail = { type, payload };
  // Additionally keep a stable snapshot in sync for GWP state payloads.
  try {
    if (payload && typeof payload === 'object' && 'giftState' in payload) {
      /** @type {any} */ (window).freeGift.snapshot = payload;
    }
  } catch {}
  // Dispatch a generic gwp:event with detail and the specific event type as well.
  try { window.dispatchEvent(new CustomEvent('gwp:event', { detail: payload })); } catch { window.dispatchEvent(new Event('gwp:event')); }
  try { window.dispatchEvent(new CustomEvent(type, { detail: payload })); } catch { /* no-op */ }
}

/**
 * Subscribes to gwp:event and invokes the callback with the current window.freeGift.detail.
 * @param {(detail: any) => void} callback - Callback when an event occurs.
 * @returns {() => void} Unsubscribe function.
 */
export function on(callback) {
  if (typeof window === 'undefined') return () => {};
  const handler = () => {
    callback(/** @type {any} */ (window).freeGift?.detail);
  };
  window.addEventListener('gwp:event', handler);
  return () => window.removeEventListener('gwp:event', handler);
}